export const TITLE_OPTIONS = [
  { code: '0001', description: 'Ms.' },
  { code: '0002', description: 'Mr.' },
  { code: '0003', description: 'Company' },
  { code: '0004', description: 'Mr. and Mrs.' },
];

export const ID_TYPE_OPTIONS = [
  { code: 'AADHAR', description: 'India: Aadhar Number' },
  { code: 'BKK100', description: 'Creditor Identification Number' },
  { code: 'BPCCOD', description: '' },
  { code: 'BPCU01', description: 'BP Customer External Identifier' },
  { code: 'BUP001', description: 'Dun & Bradstreet Number' },
  { code: 'BUP002', description: 'Commercial Register Number' },
  { code: 'BUP003', description: 'Register of Associations Number' },
  { code: 'BUP004', description: 'Public Register of Cooperatives Number' },
  { code: 'BUP005', description: 'Global Location Number' },
  { code: 'BUP006', description: 'Standard Carrier Alpha Code' },
  { code: 'BUP007', description: 'Ariba Network Identification (ANID)' },
  { code: 'BUP009', description: 'Unique SAM Entity Identifier' },
  { code: 'BUP012', description: 'Collaboration User ID' },
  { code: 'CAACN', description: '' },
  { code: 'CAFTIN', description: '' },
  { code: 'CAINDT', description: '' },
  { code: 'CAITN', description: '' },
  { code: 'CASIN', description: '' },
  { code: 'CATTN', description: '' },
  { code: 'COFA', description: 'Coface' },
  { code: 'CPID01', description: 'Counterparty number' },
  { code: 'CRCH', description: 'Credit Reform: Switzerland' },
  { code: 'CREDS', description: 'Creditsafe' },
  { code: 'CRM001', description: 'External System Identifier' },
  { code: 'CRM002', description: 'R/3 Customer Number' },
  { code: 'CRM003', description: 'External System Indicator for ICM' },
  { code: 'CRM004', description: 'R/3 Vendor Number' },
  { code: 'CRM010', description: 'R/3 Sales Organization' },
  { code: 'CRM011', description: 'R/3 Plant Number' },
  { code: 'CRM012', description: 'R/3 MRP Area' },
  { code: 'CRM020', description: '' },
  { code: 'CRRF', description: 'Creditreform' },
  { code: 'DE0001', description: '' },
  { code: 'DE0002', description: '' },
  { code: 'DES001', description: 'CDQ ID' },
  { code: 'DPI001', description: 'Corporate Data Quality' },
  { code: 'ELLI', description: 'Ellisphere' },
  { code: 'ESPACK', description: '' },
  { code: 'EXTALS', description: '' },
  { code: 'EXTCID', description: '' },
  { code: 'FS0001', description: 'ID Card' },
  { code: 'FS0002', description: 'Passport' },
  { code: 'FS0006', description: 'SWIFT-BIC (Business Identifier Code)' },
  { code: 'FS0007', description: 'Legal Entity Identifier (LEI)' },
  { code: 'FS0008', description: 'Indonesia KITAS Number' },
  { code: 'FS9100', description: 'Fuel Card' },
  { code: 'FS9150', description: 'Service Card' },
  { code: 'FS9200', description: 'Vehicle License Plate No.' },
  { code: 'HCM001', description: 'Employee ID' },
  { code: 'HCM012', description: 'Personnel Number (Main Employment)' },
  { code: 'HCM028', description: 'Internal Personnel Number' },
  { code: 'HCM030', description: 'Employee ID (Service Performer)' },
  { code: 'HCM031', description: 'Employee ID (Freelancer)' },
  { code: 'HCM032', description: 'Personnel Number (Main Employment)' },
  { code: 'HCM033', description: 'Personnel Number (Employment)' },
  { code: 'HCM034', description: 'External Employees UUID' },
  { code: 'IBS001', description: 'Social Security Number' },
  { code: 'IST001', description: 'IS Telco Password' },
  { code: 'LBN001', description: 'LBN Identification' },
  { code: 'MACRO', description: 'MSME Macro Vendor' },
  { code: 'MEDIUM', description: 'MSME Medium Vendor' },
  { code: 'NLOIN1', description: 'Organization Identification Number (OIN)' },
  { code: 'PE_RES', description: '' },
  { code: 'PHA001', description: 'Government License' },
  { code: 'PHA002', description: 'Drug Enforcement Administration Nummer' },
  { code: 'PHA003', description: 'Health Industry Number' },
  { code: 'PHA004', description: 'IMS Number' },
  { code: 'SABYID', description: 'SCRA Other Purchaser ID' },
  { code: 'SE30', description: 'TIN Outside of State' },
  { code: 'SE40', description: 'Commercial Registration Outside of State' },
  { code: 'SIBUDN', description: 'Slovenia Budget User Number' },
  { code: 'SLLCID', description: 'Customs Office Number' },
  { code: 'SLLEOR', description: 'EORI Number' },
  { code: 'SLLUSF', description: 'US: Filer Code' },
  { code: 'SMALL', description: 'MSME Small Vendor' },
  { code: 'TECH1', description: '' },
  { code: 'TM0001', description: 'Airline Code' },
  { code: 'TM0002', description: 'IATA SITA/ARINC Code (aka TTY Address)' },
  { code: 'TM0003', description: 'IATA PIMA Code' },
  { code: 'TM0004', description: 'FIRMS Code' },
  { code: 'TM0005', description: 'Participant Identification' },
  { code: 'WASTID', description: 'Waste Registration Number' },
];

export const CURRENCY_OPTIONS = [
  { code: 'ADP', description: 'Andorran Peseta (Old → EUR)' }, { code: 'AED', description: 'United Arab Emirates Dirham' },
  { code: 'AFA', description: 'Afghani (Old)' }, { code: 'AFN', description: 'Afghani' },
  { code: 'ALL', description: 'Albanian Lek' }, { code: 'AMD', description: 'Armenian Dram' },
  { code: 'ANG', description: 'Netherlands Antillean Guilder' }, { code: 'AOA', description: 'Angolanische Kwanza' },
  { code: 'AON', description: 'Angolan New Kwanza (Old)' }, { code: 'AOR', description: 'Angolan Kwanza Reajustado (Old)' },
  { code: 'ARS', description: 'Argentine Peso' }, { code: 'ATS', description: 'Austrian Schilling (Old → EUR)' },
  { code: 'AUD', description: 'Australian Dollar' }, { code: 'AWG', description: 'Aruban Florin' },
  { code: 'AZM', description: 'Azerbaijani Manat (Old)' }, { code: 'AZN', description: 'Azerbaijan Manat' },
  { code: 'BAM', description: 'Bosnia and Herzegovina Convertible Mark' }, { code: 'BBD', description: 'Barbados Dollar' },
  { code: 'BDT', description: 'Bangladesh Taka' }, { code: 'BEF', description: 'Belgian Franc (Old → EUR)' },
  { code: 'BGN', description: 'Bulgarian Lev' }, { code: 'BHD', description: 'Bahrain Dinar' },
  { code: 'BIF', description: 'Burundi Franc' }, { code: 'BMD', description: 'Bermudan Dollar' },
  { code: 'BND', description: 'Brunei Dollar' }, { code: 'BOB', description: 'Boliviano' },
  { code: 'BRL', description: 'Brazilian Real' }, { code: 'BSD', description: 'Bahaman Dollar' },
  { code: 'BTN', description: 'Bhutan Ngultrum' }, { code: 'BWP', description: 'Botswana Pula' },
  { code: 'BYB', description: 'Belarusian Ruble (Old)' }, { code: 'BYN', description: 'Belarusian Ruble' },
  { code: 'BYR', description: 'Belorussian Ruble' }, { code: 'BZD', description: 'Belize Dollar' },
  { code: 'CAD', description: 'Canadian Dollar' }, { code: 'CDF', description: 'Congolese Franc' },
  { code: 'CFP', description: 'French Franc (Pacific Islands)' }, { code: 'CHF', description: 'Swiss Franc' },
  { code: 'CLF', description: 'Chile Unidad de Fomento' }, { code: 'CLP', description: 'Chilean Peso' },
  { code: 'CLP4', description: 'CLP4' }, { code: 'CNY', description: 'Chinese Yuan Renminbi' },
  { code: 'COP', description: 'Colombian Peso' }, { code: 'CRC', description: 'Costa Rica Colon' },
  { code: 'CSD', description: 'Serbian Dinar (Old)' }, { code: 'CUC', description: 'Cuba Peso Convertible' },
  { code: 'CUP', description: 'Cuban Peso' }, { code: 'CVE', description: 'Cape Verde Escudo' },
  { code: 'CYP', description: 'Cyprus Pound (Old → EUR)' }, { code: 'CZK', description: 'Czech Krona' },
  { code: 'DEM', description: 'German Mark (Old → EUR)' }, { code: 'DEM3', description: '(Internal) German Mark (3 dec.places)' },
  { code: 'DJF', description: 'Djibouti Franc' }, { code: 'DKK', description: 'Danish Krone' },
  { code: 'DOP', description: 'Dominican Peso' }, { code: 'DZD', description: 'Algerian Dinar' },
  { code: 'ECS', description: 'Ecuadorian Sucre (Old → USD)' }, { code: 'EEK', description: 'Estonian Krone (Old → EUR)' },
  { code: 'EGP', description: 'Egyptian Pound' }, { code: 'ERN', description: 'Eritrean Nafka' },
  { code: 'ESP', description: 'Spanish Peseta (Old → EUR)' }, { code: 'ETB', description: 'Ethiopian Birr' },
  { code: 'EUR', description: 'European Euro' }, { code: 'EUR4', description: 'European Euro' },
  { code: 'FIM', description: 'Finnish Markka (Old → EUR)' }, { code: 'FJD', description: 'Fiji Dollar' },
  { code: 'FKP', description: 'Falkland Pound' }, { code: 'FRF', description: 'French Franc (Old → EUR)' },
  { code: 'GBP', description: 'British Pound' }, { code: 'GEL', description: 'Georgian Lari' },
  { code: 'GHC', description: 'Ghanaian Cedi (Old)' }, { code: 'GHS', description: 'Ghanian Cedi' },
  { code: 'GIP', description: 'Gibraltar Pound' }, { code: 'GMD', description: 'Gambian Dalasi' },
  { code: 'GNF', description: 'Guinean Franc' }, { code: 'GRD', description: 'Greek Drachma (Old → EUR)' },
  { code: 'GTQ', description: 'Guatemalan Quetzal' }, { code: 'GWP', description: 'Guinea Peso (Old → SHP)' },
  { code: 'GYD', description: 'Guyana Dollar' }, { code: 'HKD', description: 'Hong Kong Dollar' },
  { code: 'HNL', description: 'Honduran Lempira' }, { code: 'HRK', description: 'Croatian Kuna' },
  { code: 'HTG', description: 'Haitian Gourde' }, { code: 'HUF', description: 'Hungarian Forint' },
  { code: 'IDR', description: 'Indonesian Rupiah' }, { code: 'IEP', description: 'Irish Punt (Old → EUR)' },
  { code: 'ILS', description: 'Israeli Shekel' }, { code: 'INR', description: 'Indian Rupee' },
  { code: 'IQD', description: 'Iraqui Dinar' }, { code: 'IRR', description: 'Iranian Rial' },
  { code: 'ISK', description: 'Iceland Krona' }, { code: 'ITL', description: 'Italian Lira (Old → EUR)' },
  { code: 'JMD', description: 'Jamaican Dollar' }, { code: 'JOD', description: 'Jordanian Dinar' },
  { code: 'JPY', description: 'Japanese Yen' }, { code: 'KES', description: 'Kenyan Shilling' },
  { code: 'KGS', description: 'Kyrgyzstan Som' }, { code: 'KHR', description: 'Cambodian Riel' },
  { code: 'KMF', description: 'Comoros Franc' }, { code: 'KPW', description: 'North Korean Won' },
  { code: 'KRW', description: 'South Korean Won' }, { code: 'KWD', description: 'Kuwaiti Dinar' },
  { code: 'KYD', description: 'Cayman Dollar' }, { code: 'KZT', description: 'Kazakstanian Tenge' },
  { code: 'LAK', description: 'Laotian Kip' }, { code: 'LBP', description: 'Lebanese Pound' },
  { code: 'LKR', description: 'Sri Lankan Rupee' }, { code: 'LRD', description: 'Liberian Dollar' },
  { code: 'LSL', description: 'Lesotho Loti' }, { code: 'LTL', description: 'Lithuanian Lita' },
  { code: 'LUF', description: 'Luxembourg Franc (Old → EUR)' }, { code: 'LVL', description: 'Latvian Lat' },
  { code: 'LYD', description: 'Libyan Dinar' }, { code: 'MAD', description: 'Moroccan Dirham' },
  { code: 'MDL', description: 'Moldavian Leu' }, { code: 'MGA', description: 'Madagascan Ariary' },
  { code: 'MGF', description: 'Madagascan Franc (Old)' }, { code: 'MKD', description: 'Macedonian Denar' },
  { code: 'MMK', description: 'Myanmar Kyat' }, { code: 'MNT', description: 'Mongolian Tugrik' },
  { code: 'MOP', description: 'Macao Pataca' }, { code: 'MRO', description: 'Mauritanian Ouguiya' },
  { code: 'MRU', description: 'Mauritanian Ouguiya' }, { code: 'MTL', description: 'Maltese Lira (Old → EUR)' },
  { code: 'MUR', description: 'Mauritian Rupee' }, { code: 'MVR', description: 'Maldive Rufiyaa' },
  { code: 'MWK', description: 'Malawi Kwacha' }, { code: 'MXN', description: 'Mexican Pesos' },
  { code: 'MXV', description: 'Mexic Unidad de Inversión' }, { code: 'MYR', description: 'Malaysian Ringgit' },
  { code: 'MZM', description: 'Mozambique Metical (Old)' }, { code: 'MZN', description: 'Mozambique Metical' },
  { code: 'NAD', description: 'Namibian Dollar' }, { code: 'NGN', description: 'Nigerian Naira' },
  { code: 'NIO', description: 'Nicaraguan Cordoba Oro' }, { code: 'NLG', description: 'Dutch Guilder (Old → EUR)' },
  { code: 'NOK', description: 'Norwegian Krone' }, { code: 'NPR', description: 'Nepalese Rupee' },
  { code: 'NZD', description: 'New Zealand Dollars' }, { code: 'NZD5', description: 'New Zealand Dollars' },
  { code: 'OMR', description: 'Omani Rial' }, { code: 'PAB', description: 'Panamanian Balboa' },
  { code: 'PEN', description: 'Peruvian New Sol' }, { code: 'PGK', description: 'Papua New Guinea Kina' },
  { code: 'PHP', description: 'Philippine Peso' }, { code: 'PKR', description: 'Pakistani Rupee' },
  { code: 'PLN', description: 'Polish Zloty' }, { code: 'PTE', description: 'Portuguese Escudo (Old → EUR)' },
  { code: 'PYG', description: 'Paraguayan Guarani' }, { code: 'QAR', description: 'Qatar Rial' },
  { code: 'RMB', description: 'Chinese Yuan Renminbi' }, { code: 'ROL', description: 'Romanian Leu (Old)' },
  { code: 'RON', description: 'Romanian Leu' }, { code: 'RSD', description: 'Serbian Dinar' },
  { code: 'RUB', description: 'Russian Ruble' }, { code: 'RWF', description: 'Rwandan Franc' },
  { code: 'SAR', description: 'Saudi Riyal' }, { code: 'SBD', description: 'Solomon Islands Dollar' },
  { code: 'SCR', description: 'Seychelles Rupee' }, { code: 'SDD', description: 'Sudanese Dinar (Old)' },
  { code: 'SDG', description: 'Sudanese Pound' }, { code: 'SDP', description: 'Sudanese Pound (until 1992)' },
  { code: 'SEK', description: 'Swedish Krona' }, { code: 'SGD', description: 'Singapore Dollar' },
  { code: 'SHP', description: 'St.Helena Pound' }, { code: 'SIT', description: 'Slovenian Tolar (Old → EUR)' },
  { code: 'SKK', description: 'Slovakian Krona (Old → EUR)' }, { code: 'SLE', description: 'Sierra Leone Leone' },
  { code: 'SLL', description: 'Sierra Leone Leone (Old)' }, { code: 'SOS', description: 'Somalian Shilling' },
  { code: 'SRD', description: 'Surinam Dollar' }, { code: 'SRG', description: 'Surinam Guilder (Old)' },
  { code: 'SSP', description: 'South Sudanese Pound' }, { code: 'STD', description: 'Sao Tome / Principe Dobra (Old)' },
  { code: 'STN', description: 'Sao Tome / Principe Dobra' }, { code: 'SVC', description: 'El Salvador Colon' },
  { code: 'SYP', description: 'Syrian Pound' }, { code: 'SZL', description: 'Swaziland Lilangeni' },
  { code: 'THB', description: 'Thailand Baht' }, { code: 'TJR', description: 'Tajikistani Ruble (Old)' },
  { code: 'TJS', description: 'Tajikistani Somoni' }, { code: 'TMM', description: 'Turkmenistani Manat (Old)' },
  { code: 'TMT', description: 'Turkmenistani Manat' }, { code: 'TND', description: 'Tunisian Dinar' },
  { code: 'TOP', description: "Tongan Pa'anga" }, { code: 'TPE', description: 'Timor Escudo → USD' },
  { code: 'TRL', description: 'Turkish Lira (Old)' }, { code: 'TRY', description: 'Turkish Lira' },
  { code: 'TTD', description: 'Trinidad and Tobago Dollar' }, { code: 'TWD', description: 'New Taiwan Dollar' },
  { code: 'TZS', description: 'Tanzanian Shilling' }, { code: 'UAH', description: 'Ukraine Hryvnia' },
  { code: 'UF', description: 'UF' }, { code: 'UGX', description: 'Ugandan Shilling' },
  { code: 'USD', description: 'United States Dollar' }, { code: 'USDN', description: '(Internal) United States Dollar (5 Dec.)' },
  { code: 'UTM', description: 'UTM' }, { code: 'UYI', description: 'Uruguay Peso en Unidades Indexadas (UI)' },
  { code: 'UYU', description: 'Uruguayan Peso' }, { code: 'UZS', description: 'Uzbekistan Som' },
  { code: 'VEB', description: 'Venezuelan Bolivar (Old)' }, { code: 'VEF', description: 'Venezuelan Bolivar' },
  { code: 'VES', description: 'Bolivar Soberano' }, { code: 'VND', description: 'Vietnamese Dong' },
  { code: 'VUV', description: 'Vanuatu Vatu' }, { code: 'WST', description: 'Samoan Tala' },
  { code: 'XAD', description: 'Arab Accounting Dinar' }, { code: 'XAF', description: 'Gabon CFA Franc BEAC' },
  { code: 'XCD', description: 'East Carribean Dollar' }, { code: 'XCG', description: 'Caribbean Guilder' },
  { code: 'XEU', description: 'European Currency Unit (E.C.U.)' }, { code: 'XOF', description: 'Benin CFA Franc BCEAO' },
  { code: 'XPF', description: 'CFP Franc' }, { code: 'YER', description: 'Yemeni Ryal' },
  { code: 'YUM', description: 'New Yugoslavian Dinar (Old)' }, { code: 'ZAR', description: 'South African Rand' },
  { code: 'ZMK', description: 'Zambian Kwacha (Old)' }, { code: 'ZMW', description: 'Zambian Kwacha' },
  { code: 'ZRM', description: 'ZRM' }, { code: 'ZRN', description: 'Zaire (Old)' },
  { code: 'ZRO', description: 'Zaire (Old)' }, { code: 'ZWD', description: 'Zimbabwean Dollar (Old)' },
  { code: 'ZWG', description: 'Zimbabwean Gold' }, { code: 'ZWL', description: 'Zimbabwean Dollar' },
  { code: 'ZWN', description: 'Zimbabwean Dollar (Old)' }, { code: 'ZWR', description: 'Zimbabwean Dollar (Old)' },
  { code: 'ZWS', description: 'Zimbabwean Dollar (Old)' },
];

export const LANGUAGE_OPTIONS = [
  { code: 'AF', description: 'Afrikaans' }, { code: 'AR', description: 'Arabic' },
  { code: 'BG', description: 'Bulgarian' }, { code: 'CA', description: 'Catalan' },
  { code: 'CS', description: 'Czech' }, { code: 'DA', description: 'Danish' },
  { code: 'DE', description: 'German' }, { code: 'EL', description: 'Greek' },
  { code: 'EN', description: 'English' }, { code: 'ES', description: 'Spanish' },
  { code: 'ET', description: 'Estonian' }, { code: 'FI', description: 'Finnish' },
  { code: 'FR', description: 'French' }, { code: 'HE', description: 'Hebrew' },
  { code: 'HI', description: 'Hindi' }, { code: 'HR', description: 'Croatian' },
  { code: 'HU', description: 'Hungarian' }, { code: 'ID', description: 'Indonesian' },
  { code: 'IS', description: 'Icelandic' }, { code: 'IT', description: 'Italian' },
  { code: 'JA', description: 'Japanese' }, { code: 'KK', description: 'Kazakh' },
  { code: 'KO', description: 'Korean' }, { code: 'LT', description: 'Lithuanian' },
  { code: 'LV', description: 'Latvian' }, { code: 'MS', description: 'Malay' },
  { code: 'NL', description: 'Dutch' }, { code: 'NO', description: 'Norwegian' },
  { code: 'PL', description: 'Polish' }, { code: 'PT', description: 'Portuguese' },
  { code: 'RO', description: 'Romanian' }, { code: 'RU', description: 'Russian' },
  { code: 'SH', description: 'Serbian (Latin)' }, { code: 'SK', description: 'Slovak' },
  { code: 'SL', description: 'Slovenian' }, { code: 'SR', description: 'Serbian' },
  { code: 'SV', description: 'Swedish' }, { code: 'TH', description: 'Thai' },
  { code: 'TR', description: 'Turkish' }, { code: 'UK', description: 'Ukrainian' },
  { code: 'VI', description: 'Vietnamese' }, { code: 'Z1', description: 'Customer reserve' },
  { code: 'ZF', description: 'Chinese trad.' }, { code: 'ZH', description: 'Chinese' },
];

export const COUNTRY_OPTIONS = [
  { code: 'AD', description: 'Andorra' }, { code: 'AE', description: 'Utd.Arab Emir.' },
  { code: 'AF', description: 'Afghanistan' }, { code: 'AG', description: 'Antigua/Barbuda' },
  { code: 'AI', description: 'Anguilla' }, { code: 'AL', description: 'Albania' },
  { code: 'AM', description: 'Armenia' }, { code: 'AO', description: 'Angola' },
  { code: 'AQ', description: 'Antarctica' }, { code: 'AR', description: 'Argentina' },
  { code: 'AS', description: 'Samoa, America' }, { code: 'AT', description: 'Austria' },
  { code: 'AU', description: 'Australia' }, { code: 'AW', description: 'Aruba' },
  { code: 'AX', description: 'Aland Islands' }, { code: 'AZ', description: 'Azerbaijan' },
  { code: 'BA', description: 'Bosnia-Herz.' }, { code: 'BB', description: 'Barbados' },
  { code: 'BD', description: 'Bangladesh' }, { code: 'BE', description: 'Belgium' },
  { code: 'BF', description: 'Burkina Faso' }, { code: 'BG', description: 'Bulgaria' },
  { code: 'BH', description: 'Bahrain' }, { code: 'BI', description: 'Burundi' },
  { code: 'BJ', description: 'Benin' }, { code: 'BL', description: 'St Barthelemy' },
  { code: 'BM', description: 'Bermuda' }, { code: 'BN', description: 'Brunei Daruss.' },
  { code: 'BO', description: 'Bolivia' }, { code: 'BQ', description: 'Bonaire, Saba' },
  { code: 'BR', description: 'Brazil' }, { code: 'BS', description: 'Bahamas' },
  { code: 'BT', description: 'Bhutan' }, { code: 'BV', description: 'Bouvet Islands' },
  { code: 'BW', description: 'Botswana' }, { code: 'BY', description: 'Belarus' },
  { code: 'BZ', description: 'Belize' }, { code: 'CA', description: 'Canada' },
  { code: 'CC', description: 'Cocos Islands' }, { code: 'CD', description: 'Dem. Rep. Congo' },
  { code: 'CF', description: 'CAR' }, { code: 'CG', description: 'Rep.of Congo' },
  { code: 'CH', description: 'Switzerland' }, { code: 'CI', description: "Cote d'Ivoire" },
  { code: 'CK', description: 'Cook Islands' }, { code: 'CL', description: 'Chile' },
  { code: 'CM', description: 'Cameroon' }, { code: 'CN', description: 'China' },
  { code: 'CO', description: 'Colombia' }, { code: 'CR', description: 'Costa Rica' },
  { code: 'CU', description: 'Cuba' }, { code: 'CV', description: 'Cabo Verde' },
  { code: 'CW', description: 'Curaçao' }, { code: 'CX', description: 'Christmas Islnd' },
  { code: 'CY', description: 'Cyprus' }, { code: 'CZ', description: 'Czech Republic' },
  { code: 'DE', description: 'Germany' }, { code: 'DJ', description: 'Djibouti' },
  { code: 'DK', description: 'Denmark' }, { code: 'DM', description: 'Dominica' },
  { code: 'DO', description: 'Dominican Rep.' }, { code: 'DZ', description: 'Algeria' },
  { code: 'EC', description: 'Ecuador' }, { code: 'EE', description: 'Estonia' },
  { code: 'EG', description: 'Egypt' }, { code: 'EH', description: 'West Sahara' },
  { code: 'ER', description: 'Eritrea' }, { code: 'ES', description: 'Spain' },
  { code: 'ET', description: 'Ethiopia' }, { code: 'FI', description: 'Finland' },
  { code: 'FJ', description: 'Fiji' }, { code: 'FK', description: 'Falkland Islnds' },
  { code: 'FM', description: 'Micronesia' }, { code: 'FO', description: 'Faroe Islands' },
  { code: 'FR', description: 'France' }, { code: 'GA', description: 'Gabon' },
  { code: 'GB', description: 'United Kingdom' }, { code: 'GD', description: 'Grenada' },
  { code: 'GE', description: 'Georgia' }, { code: 'GF', description: 'French Guayana' },
  { code: 'GG', description: 'Guernsey' }, { code: 'GH', description: 'Ghana' },
  { code: 'GI', description: 'Gibraltar' }, { code: 'GL', description: 'Greenland' },
  { code: 'GM', description: 'Gambia' }, { code: 'GN', description: 'Guinea' },
  { code: 'GP', description: 'Guadeloupe' }, { code: 'GQ', description: 'Equatorial Guin' },
  { code: 'GR', description: 'Greece' }, { code: 'GS', description: 'S. Sandwich Ins' },
  { code: 'GT', description: 'Guatemala' }, { code: 'GU', description: 'Guam' },
  { code: 'GW', description: 'Guinea-Bissau' }, { code: 'GY', description: 'Guyana' },
  { code: 'HK', description: 'Hong Kong' }, { code: 'HM', description: 'Heard/McDon.Isl' },
  { code: 'HN', description: 'Honduras' }, { code: 'HR', description: 'Croatia' },
  { code: 'HT', description: 'Haiti' }, { code: 'HU', description: 'Hungary' },
  { code: 'ID', description: 'Indonesia' }, { code: 'IE', description: 'Ireland' },
  { code: 'IL', description: 'Israel' }, { code: 'IM', description: 'Isle of Man' },
  { code: 'IN', description: 'India' }, { code: 'IO', description: 'Brit.Ind.Oc.Ter' },
  { code: 'IQ', description: 'Iraq' }, { code: 'IR', description: 'Iran' },
  { code: 'IS', description: 'Iceland' }, { code: 'IT', description: 'Italy' },
  { code: 'JE', description: 'Jersey' }, { code: 'JM', description: 'Jamaica' },
  { code: 'JO', description: 'Jordan' }, { code: 'JP', description: 'Japan' },
  { code: 'KE', description: 'Kenya' }, { code: 'KG', description: 'Kyrgyzstan' },
  { code: 'KH', description: 'Cambodia' }, { code: 'KI', description: 'Kiribati' },
  { code: 'KM', description: 'Comoros' }, { code: 'KN', description: 'St Kitts&Nevis' },
  { code: 'KP', description: 'North Korea' }, { code: 'KR', description: 'South Korea' },
  { code: 'KW', description: 'Kuwait' }, { code: 'KY', description: 'Cayman Islands' },
  { code: 'KZ', description: 'Kazakhstan' }, { code: 'LA', description: 'Laos' },
  { code: 'LB', description: 'Lebanon' }, { code: 'LC', description: 'St. Lucia' },
  { code: 'LI', description: 'Liechtenstein' }, { code: 'LK', description: 'Sri Lanka' },
  { code: 'LR', description: 'Liberia' }, { code: 'LS', description: 'Lesotho' },
  { code: 'LT', description: 'Lithuania' }, { code: 'LU', description: 'Luxembourg' },
  { code: 'LV', description: 'Latvia' }, { code: 'LY', description: 'Libya' },
  { code: 'MA', description: 'Morocco' }, { code: 'MC', description: 'Monaco' },
  { code: 'MD', description: 'Moldova' }, { code: 'ME', description: 'Montenegro' },
  { code: 'MF', description: 'Saint Martin' }, { code: 'MG', description: 'Madagascar' },
  { code: 'MH', description: 'Marshall Islnds' }, { code: 'MK', description: 'North Macedonia' },
  { code: 'ML', description: 'Mali' }, { code: 'MM', description: 'Myanmar' },
  { code: 'MN', description: 'Mongolia' }, { code: 'MO', description: 'Macao' },
  { code: 'MP', description: 'N.Mariana Islnd' }, { code: 'MQ', description: 'Martinique' },
  { code: 'MR', description: 'Mauretania' }, { code: 'MS', description: 'Montserrat' },
  { code: 'MT', description: 'Malta' }, { code: 'MU', description: 'Mauritius' },
  { code: 'MV', description: 'Maldives' }, { code: 'MW', description: 'Malawi' },
  { code: 'MX', description: 'Mexico' }, { code: 'MY', description: 'Malaysia' },
  { code: 'MZ', description: 'Mozambique' }, { code: 'NA', description: 'Namibia' },
  { code: 'NC', description: 'New Caledonia' }, { code: 'NE', description: 'Niger' },
  { code: 'NF', description: 'Norfolk Islands' }, { code: 'NG', description: 'Nigeria' },
  { code: 'NI', description: 'Nicaragua' }, { code: 'NL', description: 'Netherlands' },
  { code: 'NO', description: 'Norway' }, { code: 'NP', description: 'Nepal' },
  { code: 'NR', description: 'Nauru' }, { code: 'NU', description: 'Niue' },
  { code: 'NZ', description: 'New Zealand' }, { code: 'OM', description: 'Oman' },
  { code: 'PA', description: 'Panama' }, { code: 'PE', description: 'Peru' },
  { code: 'PF', description: 'Frenc.Polynesia' }, { code: 'PG', description: 'Pap. New Guinea' },
  { code: 'PH', description: 'Philippines' }, { code: 'PK', description: 'Pakistan' },
  { code: 'PL', description: 'Poland' }, { code: 'PM', description: 'St.Pier,Miquel.' },
  { code: 'PN', description: 'Pitcairn Islnds' }, { code: 'PR', description: 'Puerto Rico' },
  { code: 'PS', description: 'Palestine' }, { code: 'PT', description: 'Portugal' },
  { code: 'PW', description: 'Palau' }, { code: 'PY', description: 'Paraguay' },
  { code: 'QA', description: 'Qatar' }, { code: 'RE', description: 'Reunion' },
  { code: 'RO', description: 'Romania' }, { code: 'RS', description: 'Serbia' },
  { code: 'RU', description: 'Russian Fed.' }, { code: 'RW', description: 'Rwanda' },
  { code: 'SA', description: 'Saudi Arabia' }, { code: 'SB', description: 'Solomon Islands' },
  { code: 'SC', description: 'Seychelles' }, { code: 'SD', description: 'Sudan' },
  { code: 'SE', description: 'Sweden' }, { code: 'SG', description: 'Singapore' },
  { code: 'SH', description: 'Saint Helena' }, { code: 'SI', description: 'Slovenia' },
  { code: 'SJ', description: 'Svalbard' }, { code: 'SK', description: 'Slovakia' },
  { code: 'SL', description: 'Sierra Leone' }, { code: 'SM', description: 'San Marino' },
  { code: 'SN', description: 'Senegal' }, { code: 'SO', description: 'Somalia' },
  { code: 'SR', description: 'Suriname' }, { code: 'SS', description: 'South Sudan' },
  { code: 'ST', description: 'S.Tome,Principe' }, { code: 'SV', description: 'El Salvador' },
  { code: 'SX', description: 'Sint Maarten' }, { code: 'SY', description: 'Syria' },
  { code: 'SZ', description: 'Eswatini' }, { code: 'TC', description: 'Turksh Caicosin' },
  { code: 'TD', description: 'Chad' }, { code: 'TF', description: 'French S.Territ' },
  { code: 'TG', description: 'Togo' }, { code: 'TH', description: 'Thailand' },
  { code: 'TJ', description: 'Tajikistan' }, { code: 'TK', description: 'Tokelau Islands' },
  { code: 'TL', description: 'Timor-Leste' }, { code: 'TM', description: 'Turkmenistan' },
  { code: 'TN', description: 'Tunisia' }, { code: 'TO', description: 'Tonga' },
  { code: 'TR', description: 'Türkiye' }, { code: 'TT', description: 'Trinidad,Tobago' },
  { code: 'TV', description: 'Tuvalu' }, { code: 'TW', description: 'Taiwan' },
  { code: 'TZ', description: 'Tanzania' }, { code: 'UA', description: 'Ukraine' },
  { code: 'UG', description: 'Uganda' }, { code: 'UM', description: 'Minor Outl.Isl.' },
  { code: 'US', description: 'USA' }, { code: 'UY', description: 'Uruguay' },
  { code: 'UZ', description: 'Uzbekistan' }, { code: 'VA', description: 'Vatican City' },
  { code: 'VC', description: 'St. Vincent' }, { code: 'VE', description: 'Venezuela' },
  { code: 'VG', description: 'Brit.Virgin Is.' }, { code: 'VI', description: 'Amer.Virgin Is.' },
  { code: 'VN', description: 'Vietnam' }, { code: 'VU', description: 'Vanuatu' },
  { code: 'WF', description: 'Wallis,Futuna' }, { code: 'WS', description: 'Samoa' },
  { code: 'YE', description: 'Yemen' }, { code: 'YT', description: 'Mayotte' },
  { code: 'ZA', description: 'South Africa' }, { code: 'ZM', description: 'Zambia' },
  { code: 'ZW', description: 'Zimbabwe' },
];

export const VENDOR_TABS = [
  {
    id: 'general',
    label: 'General',
    fields: [
      { key: 'business_partner_number', label: 'Business Partner Number' },
      { key: 'company_code', label: 'Company Code', required: true, type: 'searchselect', dynamic: true },
      { key: 'bp_grouping',            label: 'Business Partner Grouping', required: true },
      { key: 'bp_title', label: 'Title', required: true, type: 'searchselect', options: TITLE_OPTIONS },
      { key: 'id_type', label: 'ID Type', type: 'searchselect', options: ID_TYPE_OPTIONS },
      { key: 'id_number', label: 'ID Number' },

      { key: 'name_1',                 label: 'Name 1',                  required: true },
      { key: 'name_2',                 label: 'Name 2' },
      { key: 'search_term_1',          label: 'Search Term 1' },
      { key: 'search_term_2',          label: 'Search Term 2' },
      { key: 'language_key', label: 'Language Key', type: 'searchselect', options: LANGUAGE_OPTIONS },
    ],
  },
  {
    id: 'address',
    label: 'Address',
    fields: [
      { key: 'street',            label: 'Street',       required: true },
      { key: 'house_number',      label: 'House Number', required: true },
      { key: 'street_1',          label: 'Street 1',     required: true },
      { key: 'street_2',          label: 'Street 2' },
      { key: 'street_3',          label: 'Street 3' },
      { key: 'city_postal_code',  label: 'City Postal Code', required: true },
      { key: 'city_1',            label: 'City 1',       required: true },
      { key: 'city_2_district',   label: 'City 2 - District' },
      { key: 'country_key', label: 'Country Key', required: true, type: 'searchselect', options: COUNTRY_OPTIONS },
      { key: 'region',            label: 'Region (State, Province, County)', required: true },
    ],
  },
  {
    id: 'contact',
    label: 'Contact',
    fields: [
      { key: 'mobile_number_01', label: 'Mobile Number 01', type: 'tel' },
      { key: 'mobile_number_02', label: 'Mobile Number 02', type: 'tel' },
      { key: 'email_address',    label: 'E-Mail (1) Address', type: 'email' },
    ],
  },
  {
    id: 'bank',
    label: 'Bank Details',
    fields: [
      { key: 'bank_id',                     label: 'Bank ID',       required: true },
      { key: 'bank_country_region_key', label: 'Country/Region Key of Bank', required: true, type: 'searchselect', options: COUNTRY_OPTIONS },
      { key: 'bank_key_ifsc',               label: 'Bank Key (IFSC)', required: true },
      { key: 'bank_account_number',         label: 'Bank Account Number', required: true },
      { key: 'account_holder_name',         label: 'A/C Holder Name' },
      { key: 'reconciliation_account',      label: 'Reconciliation Account in General Ledger' },
    ],
  },
  {
    id: 'payment',
    label: 'Payment & Terms',
    fields: [
      { key: 'planning_group',        label: 'Planning Group' },
      { key: 'terms_of_payment_key',  label: 'Terms of Payment Key', required: true },
      { key: 'double_invoice_check',  label: 'Check Flag for Double Invoices or Credit Memos', type: 'yesno', required: true },
      { key: 'payment_methods',       label: 'List of Respected Payment Methods' },
      { key: 'alternative_payee_acct', label: 'Account Number of the Alternative Payee' },
      { key: 'purchase_organisation', label: 'Purchase Organisation', required: true },
      { key: 'order_currency', label: 'Order Currency', required: true, type: 'searchselect', options: CURRENCY_OPTIONS },
      { key: 'payment_terms',         label: 'Payt Terms' },
      { key: 'incoterms',             label: 'Incoterms' },
      { key: 'incoterms_2',           label: 'Incoterms 2' },
    ],
  },
  {
    id: 'tax',
    label: 'Tax & Compliance',
    fields: [
      { key: 'withholding_tax_type',      label: 'Withholding Tax Type',      type: 'searchselect', dynamic: true },
      { key: 'withholding_tax_number',    label: 'Withholding Tax Number' },
      { key: 'withholding_tax_code_type', label: 'Withholding Tax Code Type', type: 'searchselect', dynamic: true },
      { key: 'exemption_certificate_no',  label: 'Exe. Certificate No.' },
      { key: 'exemption_rate',            label: 'Exemption Rate',     type: 'number' },
      { key: 'exemption_start_date',      label: 'Date on Which Exemption Begins', type: 'date' },
      { key: 'exemption_end_date',        label: 'Date on Which Exemption Ends',   type: 'date' },
      { key: 'pan_number',                label: 'PAN Number', required: true },
      { key: 'gst_tax_type',              label: 'GST Tax Type' },
      { key: 'gstn_number',               label: 'GSTN Number' },
    ],
  },
  {
    id: 'invoice_check',
    label: 'Invoice Check',
    fields: [
      { key: 'gr_based_iv_check',       label: 'GR-Based IV Check' },
      { key: 'service_based_iv_check',  label: 'Service-Based IV Check' },
      { key: 'kalsk_schema_supplier',   label: 'Supplier Schema' },
    ],
  },
];

export const VENDOR_FIELDS = VENDOR_TABS.flatMap(t => t.fields);
